import { DEFAULT_DRAW_TIME, DEFAULT_GUESS_TIME, DRAW_TIME_MAX, DRAW_TIME_MIN, DRAW_TIME_OPTIONS, GUESS_TIME_MAX, GUESS_TIME_MIN, GUESS_TIME_OPTIONS, MIN_PLAYERS, } from './constants.js';
/** Temps de dessin du mode collaboratif : court, la manche se repete N fois. */
const COLLAB_DRAW = {
    options: [20, 30, 40],
    min: 20,
    max: 40,
    fallback: 30,
    free: false,
};
/**
 * Temps de vote du mode collaboratif.
 *
 * Bien plus long qu'ailleurs : on ne juge pas une image, on regarde N tableaux
 * se construire retouche par retouche avant de pouvoir choisir. Le selecteur
 * s'arrete a 90 s, la valeur libre monte a 120 : au-dela, une table entiere
 * attend un votant qui a le temps de faire autre chose.
 */
const COLLAB_VOTE = {
    options: [45, 60, 90],
    min: 45,
    max: 120,
    fallback: 60,
    free: true,
};
const STANDARD_DRAW = {
    options: DRAW_TIME_OPTIONS,
    min: DRAW_TIME_MIN,
    max: DRAW_TIME_MAX,
    fallback: DEFAULT_DRAW_TIME,
    free: true,
};
const STANDARD_GUESS = {
    options: GUESS_TIME_OPTIONS,
    min: GUESS_TIME_MIN,
    max: GUESS_TIME_MAX,
    fallback: DEFAULT_GUESS_TIME,
    free: true,
};
/**
 * Manches du mode collaboratif.
 *
 * Une manche = un cran de rotation, donc un tableau de plus pour chacun. Trois
 * par defaut : c'est ce qu'il faut pour qu'un tableau ait une histoire sans que
 * la partie s'eternise, la duree totale etant le produit des manches par le
 * temps de dessin.
 */
const COLLAB_ROUNDS = {
    options: [1, 2, 3, 4, 5],
    min: 1,
    max: 5,
    fallback: 3,
    free: false,
};
/**
 * Plage du reglage de manches pour ce mode.
 *
 * `null` quand le mode l'ignore (battle royale) ou compte autre chose que des
 * manches (« un seul dessine » compte des tours) : ces deux cas ont deja leur
 * traitement, cette table ne s'occupe que des plages ordinaires.
 */
export function roundsRange(mode) {
    return mode === 'collab' ? COLLAB_ROUNDS : null;
}
/** Plage du temps de dessin pour ce mode. */
export function drawTimeRange(mode) {
    return mode === 'collab' ? COLLAB_DRAW : STANDARD_DRAW;
}
/**
 * Plage du second chrono. Il s'appelle « temps pour trouver » partout, « temps
 * pour voter » dans les modes ou personne ne cherche.
 */
export function guessTimeRange(mode) {
    return mode === 'collab' ? COLLAB_VOTE : STANDARD_GUESS;
}
/** La valeur est-elle acceptable pour ce mode ? */
export function isValidTime(range, value) {
    if (typeof value !== 'number' || !Number.isInteger(value))
        return false;
    if (value < range.min || value > range.max)
        return false;
    // Sans valeur libre, seuls les raccourcis passent : c'est la seule facon de
    // tenir la promesse « pas d'autre valeur » cote serveur aussi.
    return range.free || range.options.includes(value);
}
/**
 * Ramene une valeur dans la plage du mode.
 *
 * Sert au CHANGEMENT DE MODE, et il est indispensable : un salon regle sur 120 s
 * de dessin qui bascule en collaboratif porterait une duree que le mode refuse.
 * L'hote verrait un refus sur un reglage qu'il n'a pas touche. On le ramene
 * donc en silence, au raccourci le plus proche quand il n'y a pas de valeur
 * libre.
 */
export function clampTime(range, value) {
    if (isValidTime(range, value))
        return value;
    if (!range.free) {
        return range.options.reduce((best, option) => Math.abs(option - value) < Math.abs(best - value) ? option : best, range.options[0]);
    }
    return Math.min(Math.max(Math.round(value), range.min), range.max);
}
/**
 * Effectif minimal pour ce mode.
 *
 * Trois joueurs des qu'on VOTE, et la raison est arithmetique : on ne vote pas
 * pour soi. A deux, chacun n'aurait qu'un seul choix possible, le vote ne
 * dirait donc rien et chaque partie finirait ex aequo. La regle vaut pour le
 * concours autant que pour le collaboratif.
 */
export function minPlayersFor(mode) {
    return mode === 'contest' || mode === 'collab' ? 3 : MIN_PLAYERS;
}
//# sourceMappingURL=modeSettings.js.map